import styled from 'styled-components';
import { breakPoint, COLORS } from '@ertelecom/ui-react/assets/js/constants';
import DefaultPopup from '@ertelecom/ui-react/components/popups/defaultPopup';
import FilterTags from  '@ertelecom/ui-react/components/navigation/filterTags';
import ChannelSearch from '../search';
import ChannelTooltip from '../tooltip';

export const Popup = styled(DefaultPopup)`
    @media (max-width: 859px) {
        width: auto !important;
    }

    @media(${breakPoint(320)}) {
        height: calc(100vh - 140px) !important;
        margin-top: 70px !important;
        overflow-y: hidden !important;
    }
`;

export const Header = styled.div`
    background: #333333;
    height: 140px;
    display: block;
    padding: 43px 60px;

    @media(${breakPoint(1366)}) {
        padding: 43px 56px;
    }

    @media(${breakPoint(768)}) {
        padding: 33px 30px;
    }

    @media(${breakPoint(320)}) {
        padding: 23px 16px;
        height: auto;
    }
`;

export const TariffName = styled.span`
    display: block;
    color: ${COLORS.white};
    font: 400 14px/1.29 "Roboto", sans-serif;

    @media(${breakPoint(320)}) {
        font-size: 10px;
    }
`;

export const Title = styled.span`
    display: block;
    color: ${COLORS.white};
    font: 400 24px/1.33 "Roboto", sans-serif;
    margin-top: 2px;

    @media(${breakPoint(320)}) {
        font-size: 16px;
    }
`;

export const Body = styled.div`
    padding: 26px 80px;
    display: block;

    @media(${breakPoint(1366)}) {
        padding: 26px 56px;
    }

    @media(${breakPoint(768)}) {
        padding: 26px 30px;
    }

    @media(${breakPoint(320)}) {
        padding: 26px 16px;
        height: 100%;
    }
`;

export const Search = styled(ChannelSearch)`
    width: 100%;
    max-width: 100%;
`;

export const Filter = styled(FilterTags)`
    margin-top: 28px;

    @media(${breakPoint(768)}) {
        margin-top: 26px;
    }

    & > div {
        padding: 3px 13px;

        @media (max-width: 1079px) {
            padding: 0;

            & > div {
                padding: 3px 13px;
            }
        }
    }
`;

export const SearchQuery = styled.span`
    font: 300 20px/28px "Roboto", sans-serif;
    color: ${COLORS.black};
    display: block;
    margin-top: 15px;
    border-top: 1px solid ${COLORS.outlineGrey};
    padding-top: 16px;

    @media(${breakPoint(768)}) {
        margin-top: 10px;
    }
`;

export const ChannelsDescription = styled.span`
    font: 300 16px/24px "Roboto", sans-serif;
    color: ${COLORS.darkGrey};
    display: block;
    margin-top: 2px;
`;

export const Result = styled.div`
    position: relative;
    display: block;
    height: 220px;
    margin-top: 5px;

    @media(${breakPoint(320)}) {
        height: calc(100% - 190px);
    }

    &::before,
    &::after {
        content: "";
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 20px;
        background: linear-gradient(to bottom, rgba(255,255,255,1), rgba(255,255,255,0));
    }

    &::after {
        top: auto;
        bottom: 0;
        background: linear-gradient(to top, rgba(255,255,255,1), rgba(255,255,255,0));
    }
`;

export const ResultItems = styled.div`
    display: flex;
    flex-wrap: wrap;
    overflow-y: auto;
    height: 100%;
    padding-top: 20px;
    padding-bottom: 20px;
    align-items: flex-start;
`;

export const Channel = styled(ChannelTooltip)`
    width: 25%;
    padding-right: 10px;
    margin-right: 0;

    @media(${breakPoint(1024)}) {
        width: 33.333333%;
    }

    @media(${breakPoint(320)}) {
        width: 100%;
    }

    @media (max-width: 1280px) {
        display: flex;
        margin-bottom: 12px;
    }
`;
